// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"about-module--pageContainer--fLrrl","pageText":"about-module--pageText--srQmH"};